export default "/static/ot_flex_tiny.png";